module.exports = __webpack_public_path__ + "img/index-honor33.64f239a0.png";